import {getMarketCode, getSegmentCode, isLoggedIn} from "@kissui/helpers/src/dataLayer";
import {
    B2B_PRICE_DISPLAY_ALL, B2B_PRICE_DISPLAY_ONLY_AUTHENTICATED,
    COVEO_ACCESS_TOKEN,
    COVEO_ACCESS_TOKEN_B2B
} from "./search-bar/constants";
import {ProductResult } from "./experimental/engine";

interface Config {
    experimentalSearch: {
        enabledMarkets: string[];
    };
}

const sessionKey = 'nn_searchConfigData_C6_R0';

async function fetchConfigData(): Promise<Config> {
    const signal = AbortSignal.timeout(3000)
    const response = await fetch('/shared_res/agility/coveo-search/config.json', { signal })

    if (response.ok) {
        const config = await response.json()
        sessionStorage.setItem(sessionKey, JSON.stringify(config))
        return config
    } else {
        throw new Error('SEARCH_CONFIG_FETCH_ERROR')
    }
}

async function getConfig(): Promise<Config> {
  const configData = sessionStorage.getItem(sessionKey)

  return configData ? JSON.parse(configData) : fetchConfigData()
}

export async function getExperimentalMode(): Promise<boolean> {
    try {
        const isB2B = getSegmentCode().toUpperCase() === 'B2B'
        const hasExperimentalFlag = window.location.href.includes('experimental-search')
        const forceExperimental = isB2B || hasExperimentalFlag

        if (forceExperimental) {
            return true
        }

        const currentMarket = getMarketCode()?.toUpperCase()
        const config = await getConfig()
        const enabledMarkets = config?.experimentalSearch?.enabledMarkets ?? []

        return !!enabledMarkets?.includes(currentMarket)
    } catch (error) {
        return false
    }
}

export function isB2B() : boolean {
    return getSegmentCode().toUpperCase() === 'B2B'
}

export function getCoveoAccessToken() : string {
    return isB2B() ? COVEO_ACCESS_TOKEN_B2B : COVEO_ACCESS_TOKEN
}

// Check price condition only of B2B
export const showPriceSection = (result: ProductResult) : boolean=> {
    if(!isB2B()){
        return true
    }
    return isB2B() ? result.price !== undefined : true;
}

// check if the flag nes_prd_price_display is set
export const displayPrice = (result: ProductResult) : boolean => {
    if(!isB2B()){
        return true
    }

    const isPublicPrice = result.priceDisplay === B2B_PRICE_DISPLAY_ALL;
    const isAuthenticatedPrice = result.priceDisplay === B2B_PRICE_DISPLAY_ONLY_AUTHENTICATED && !!isLoggedIn();
    return isPublicPrice || isAuthenticatedPrice;
}

export const getTaxSystemTariff = async () => {
    if(!isB2B()){
        return ''
    }
    let taxSystemTariff = ''
    if(!isLoggedIn()){
        const { taxSystem, tariff } = await window.napi.market().read()
        taxSystemTariff = `${taxSystem}_${tariff}`
    }
    else {
        const { taxSystem, tariff } = await window.napi.customer().read()
        taxSystemTariff = `${taxSystem}_${tariff}`
    }

    return taxSystemTariff
}

export function setSearchedQuery(query: string): void {
    sessionStorage.setItem('searchedQuery-sessionKey', query)
}

export function getSearchedQuery(): string | null {
    return sessionStorage.getItem('searchedQuery-sessionKey')
}

export function deleteSearchedQuery(): void {
    sessionStorage.removeItem('searchedQuery-sessionKey')
}

